/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import React from 'react';

export default function Model(props) {
  return (
    <group {...props} dispose={null} castShadow receiveShadow >
      <mesh castShadow receiveShadow material={props.model.materials.Sand_Shader} geometry={props.model.nodes.Corner_Sand.geometry} />
      <mesh castShadow receiveShadow material={props.model.materials.Wood_Shader} geometry={props.model.nodes.Corner_Wooden_Plank_01.geometry} />
      <mesh castShadow receiveShadow material={props.model.materials.Wood_Shader} geometry={props.model.nodes.Corner_Wooden_Plank_02.geometry} />
    </group>
  )
}
